var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"custom-modal-content"},_vm._l((_vm.commoditiesExcluded),function(item){return _c('li',{key:item.id,staticClass:"custom-modal-item"},[_vm._v(" "+_vm._s(item)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }